import { Map as ImmutableMap } from 'immutable';
import React, { type ReactNode } from 'react';

import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import type { SxProps, Theme } from '@mui/material/styles';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

import { useAppDispatch, useAppSelector } from 'hooks/redux';

type ReportProblemLinkProps = {
  feedbackSubject?: string;
  /** Files the person can choose to send, by name. */
  attachments?: Record<string, Blob>;
  children?: ReactNode;
  type?: 'button';
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  sx?: SxProps<Theme>;
};

const ReportProblemLink = ({
  feedbackSubject,
  attachments,
  children,
  type,
  onClick,
  sx,
}: ReportProblemLinkProps): React.JSX.Element | null => {
  const dispatch = useAppDispatch();
  const feedback = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'feedback'));

  if (!feedback) {
    return null;
  }

  const openDialog = (event: React.MouseEvent<HTMLElement>) => {
    dispatch(
      rootUiActions.createDialog(
        rootUiTypes.mkRootUiData({
          id: 'report-error',
          type: 'DIALOG_TYPE_REPORT_ERROR',
          allowNesting: true,
          props: ImmutableMap({
            feedbackSubject,
            attachments,
          }),
        }),
      ),
    );
    onClick?.(event);
  };

  if (type === 'button') {
    return (
      <Button variant='tonal' onClick={openDialog} sharedcomponentid='REPORT_PROBLEM_LINK' sx={sx}>
        {children || 'Send feedback'}
      </Button>
    );
  }

  return (
    <Link component='button' onClick={openDialog} sharedcomponentid='REPORT_PROBLEM_LINK' underline='none' sx={sx}>
      {children || 'Send feedback'}
    </Link>
  );
};

export default ReportProblemLink;
